<template>
  <div>
    <ValidationObserver ref="observer">
      <v-row v-for="[key, item] in Object.entries(items)" :key="key">
        <v-col
          v-if="key.startsWith(key_start) && item.type == 'text'"
          cols="12"
        >
          <ValidationProvider
            v-slot="{ errors, valid }"
            :name="item.text"
            :rules="item.rules"
          >
            <div class="text-subtitle-1 black--text font-weight-bold mb-2">
              {{ item.question }}
            </div>
            <v-text-field
              ref="refShopProp"
              v-model="shop_prop[key]"
              :name="key"
              :error-messages="errors"
              :success="valid"
              :label="item.text"
              :placeholder="item.placeholder"
              outlined
              :counter="item.counter"
              background-color="white"
              :hint="item.hint"
              :disabled="disabled"
              persistent-hint
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col
          v-else-if="key.startsWith(key_start) && item.type == 'number'"
          cols="6"
          sm="4"
        >
          <ValidationProvider
            v-slot="{ errors, valid }"
            :name="item.text"
            :rules="item.rules"
          >
            <div class="text-subtitle-1 black--text font-weight-bold mb-2">
              {{ item.question }}
            </div>
            <v-text-field
              ref="refShopProp"
              v-model="shop_prop[key]"
              :name="key"
              :success="valid"
              :error-messages="errors"
              :label="item.text"
              :placeholder="item.placeholder"
              outlined
              background-color="white"
              :hint="item.hint"
              :disabled="disabled"
              persistent-hint
              type="number"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
  computed,
  onMounted,
} from "@vue/composition-api";

import utilFunc from "@/common/utilFunc.js";

export default defineComponent({
  props: ["key_start", "items", "shop_prop", "disabled"],
  setup(props, ctx) {
    const refShopProp = ref();

    const errorCheck = async () => {
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        // エラーあり エラー箇所に移動
        let item_name = "";
        Object.keys(ctx.refs.observer.errors).forEach(function (key) {
          if (ctx.refs.observer.errors[key].length > 0) {
            item_name = key;
            return;
          }
        });
        const errorKey = utilFunc.getKeyByItemText(props.items, item_name);
        // ctx.refs.refShopPropからエラー箇所を特定してスクロール
        ctx.refs.refShopProp.forEach((el) => {
          if (el.$el.querySelector("input").name === errorKey) {
            el.$el.scrollIntoView({ block: "center" });
          }
        });
        return false;
      }
      return true;
    };

    return {
      refShopProp,
      errorCheck,
    };
  },
});
</script>
